import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import DraftPopup from "../../Published/ongoing_threeDot_ppup/DraftPopup";
import Delete from "../../confirmation_Screen/Delete";
import { BookText, CalendarDays } from "lucide-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const DraftAssessBox = ({
  assessment,
  setDeactiveProcess,
  getDraftAssessment,
}) => {
  const navigate = useNavigate();
  const [delete1, setDelete1] = useState(false);
  const [showUnsavedPrompt, setShowUnsavedPrompt] = useState(false);
  const [pendingNav, setPendingNav] = useState(false);
  const { id, name, section_id, standard_id, subject_id, updated_at } =
    assessment;
  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const reduceSubjectName = (text, length) => {
    if (text.length < length) {
      return text;
    }
    return text.slice(0, length) + "...";
  };

  const subjectColor =
    "#" + (assessment?.subject_id?.subject_color || "000000");

  const handleNavClick = (e) => {
    if (e.target.closest && e.target.closest('[data-no-nav="true"]')) {
      // click came from popup trigger — ignore navigation
      return;
    }
    const localSaved = localStorage.getItem(`DraftQAssesmentLocal-${id}`);
    console.log("localSaved found");
    if (localSaved) {
      setShowUnsavedPrompt(true); // show dialog first
      setPendingNav(true); // mark navigation pending
    } else {
      // no unsaved changes → direct navigate
      navigate("/DaftQLists", {
        state: {
          assessmentId: id,
          adaptive: assessment.isAdaptive,
          autoEvaluate: assessment?.autoEvalEnabled,
        },
      });
    }
  };

  return (
    <>
      <div
        className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4"
        style={{
          backgroundColor: "#FDEFE3",
          borderTop: `4px solid ${subjectColor}`,
          borderRight: "4px solid #8D4B28",
          borderBottom: "1px solid #8D4B28",
          borderLeft: "1px solid #8D4B28",
          borderRadius: "0.75rem",
          cursor: "pointer",
        }}
        onClick={handleNavClick}
      >
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div>
            {`${standard_id?.name} - ${section_id?.name} | `}{" "}
            <span title={subject_id?.name} className="poppins-semibold">
              {reduceSubjectName(subject_id?.name, 18)}
            </span>
          </div>
          {assessment.isAdaptive && (
            <span
              style={{
                padding: "7px 12px",
                position: "absolute",
                top: "20px",
                right: "3%",
                borderRadius: "6px",
              }}
            >
              <img
                src="/images/adaptiveImg.png"
                alt="img"
                style={{ width: "70px" }}
              />
            </span>
          )}
          {assessment?.autoEvalEnabled && (
            <span
              style={{
                padding: "0px 12px",
                position: "absolute",
                top: "24px",
                right: "3%",
                borderRadius: "6px",
              }}
            >
              <img
                src="/images/auto-eva.png"
                alt="img"
                style={{ width: "45px" }}
              />
            </span>
          )}
          <div data-no-nav="true" onClick={(e) => e.stopPropagation()}>
            <Popup
              trigger={
                <img
                  src="/images/menu-dots-vertical 1.svg"
                  className="hw_card_three_dot"
                  alt=""
                />
              }
              content={
                <div className="hw_popup_box_size">
                  <DraftPopup
                    id={id}
                    setDelete={setDelete1}
                    isAdaptive={assessment?.isAdaptive}
                    autoEvaluate={assessment?.autoEvalEnabled}
                  />
                </div>
              }
              on="click"
              hideOnScroll
              position="bottom right"
            />
          </div>
        </div>

        <div className="d-flex align-items-center mb-1">
          <BookText size={16} className="me-2 text-dark" />
          <div className=" text-truncate poppins-semibold" title={name}>
            {reduceSubjectName(name, 30)}
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-between text-muted"
          style={{ fontSize: "0.875rem" }}
        >
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="d-flex align-items-start">
              <CalendarDays size={16} className="me-2 mt-1 text-dark" />

              <div className="d-flex flex-column">
                <small className="me-1"> Updated On : </small>
                <div
                  className="d-flex justify-content-between align-items-center "
                  style={{ width: "100%" }}
                >
                  <small className=" text-dark">{timeHelper(updated_at)}</small>
                </div>
              </div>
            </div>
            <span
              style={{
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: 600,
                fontSize: "12px",
                lineHeight: "18px",
                color: "#666666",
              }}
            >
              Draft
            </span>
          </div>
        </div>
      </div>
      {delete1 && (
        <Delete
          assessmentId={id}
          setDeactiveProcess={setDeactiveProcess}
          setDelete={setDelete1}
          getDraftAssessment={getDraftAssessment}
        />
      )}
      {
        <Dialog
          open={showUnsavedPrompt}
          onClose={() => setShowUnsavedPrompt(false)}
        >
          <DialogTitle>Unsaved Changes Found</DialogTitle>
          <DialogContent>
            <DialogContentText>
              You already have unsaved changes. Do you want to restore?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setShowUnsavedPrompt(false);
              }}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                setShowUnsavedPrompt(false);
                navigate("/DaftQLists", {
                  state: {
                    assessmentId: id,
                    adaptive: assessment.isAdaptive,
                    autoEvaluate: assessment?.autoEvalEnabled,
                    localData: true,
                  },
                });
              }}
              variant="contained"
            >
              Continue
            </Button>
            <Button
              onClick={() => {
                localStorage.removeItem(`DraftQAssesmentLocal-${id}`);
                setShowUnsavedPrompt(false);
                navigate("/DaftQLists", {
                  state: {
                    assessmentId: id,
                    adaptive: assessment.isAdaptive,
                    autoEvaluate: assessment?.autoEvalEnabled,
                  },
                });
              }}
              color="error"
              variant="outlined"
            >
              Ignore
            </Button>
          </DialogActions>
        </Dialog>
      }
    </>
  );
};

export default DraftAssessBox;
